export default {
  title: 'Member Level Privilege',
  addLevel: 'Add Member Level',
  levelName: 'Level Name',
  levelNamePlaceholder: 'Please enter level name',
  addI18n: 'Add Translations',
  addTitle: 'Add Member Level',
  editTitle: 'Edit Member Level',
  deleteConfirm: 'This action cannot be undone. Are you sure to delete?',
  columns: {
    level: 'Level',
    name: 'Level Name',
    growth: 'Growth Required',
    memberCount: 'Member Count',
    sort: 'Sort',
    status: 'Status',
    benefitCount: 'Members',
  },
  form: {
    baseInfo: 'Basic Info',
    levelName: 'Member Level Name',
    levelNamePlaceholder: 'Please enter level name',
    levelNameRequired: 'Please enter level name',
    namePlaceholder: 'Please enter level name',
    growthValue: 'Member Growth Value',
    growthValuePlaceholder: 'Please enter growth value',
    growthValueRequired: 'Please enter growth value',
    birthdayGift: 'Birthday Gift',
    birthdayGiftDesc: 'Points will be automatically awarded on user\'s birthday',
    sendPoints: 'Send Points',
    pointsPlaceholder: 'Please enter',
    pointsUnit: 'Points',
    birthdayPointsRequired: 'Please enter points amount',
    discountPrivilege: 'Discount Privilege',
    discountPrivilegeDesc: 'Enjoy discount when redeeming gifts with points',
    pointsExchangeGift: 'Redeem Gift with Points',
    discountPlaceholder: 'Please enter',
    discountUnit: 'off',
    discountRequired: 'Please enter discount value',
  },
  i18nEditTitle: 'Edit Translations',
  i18nModal: {
    title: 'Translations (Level Name)',
    nameSuffix: ' Level Name',
  },
};
